import React from 'react';
import BackButton from '@/components/BackButton';

const Security: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Security</h1>
          
          <h2>Our Security Commitment</h2>
          <p>
            At NEXUS Phish, security is our top priority. We implement comprehensive security measures 
            to protect our platform and your data.
          </p>

          <h2>Security Features</h2>
          <ul>
            <li>
              <strong>End-to-End Encryption</strong>
              <p>All data transmission is encrypted using industry-standard protocols.</p>
            </li>
            <li>
              <strong>Secure Authentication</strong>
              <p>Multi-factor authentication and secure session management.</p>
            </li>
            <li>
              <strong>Data Protection</strong>
              <p>Regular backups and strict access controls for all stored data.</p>
            </li>
            <li>
              <strong>Regular Audits</strong>
              <p>Continuous security assessments and vulnerability testing.</p>
            </li>
          </ul>

          <h2>Responsible Disclosure</h2>
          <p>
            We encourage security researchers to responsibly disclose any vulnerabilities found in our platform:
          </p>
          <ol>
            <li>Submit detailed reports to security@nexuscipherguard.com</li>
            <li>Include steps to reproduce the vulnerability</li>
            <li>Allow reasonable time for assessment and patching</li>
            <li>Maintain confidentiality until resolution</li>
          </ol>

          <h2>Security Best Practices</h2>
          <ul>
            <li>Regularly update your credentials</li>
            <li>Use strong, unique passwords</li>
            <li>Enable two-factor authentication</li>
            <li>Monitor account activity</li>
            <li>Report suspicious behavior</li>
          </ul>

          <h2>Compliance</h2>
          <p>
            Our security measures comply with industry standards and regulations:
          </p>
          <ul>
            <li>ISO 27001 Security Standards</li>
            <li>GDPR Compliance</li>
            <li>Data Protection Guidelines</li>
            <li>Regular Security Assessments</li>
          </ul>

          <h2>Contact Security Team</h2>
          <p>
            For security-related inquiries or to report vulnerabilities:
          </p>
          <ul>
            <li>Email: security@nexuscipherguard.com</li>
            <li>Emergency: +91 XXXXXXXXXX</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Security;